import { RentalFlow } from "../RentalFlow";
import { CartFlowController } from "../../CartFlowController";
import { ICartItems } from "../../../../Interfaces/Cart";

export class Accessories extends RentalFlow {
    protected allowMultiselect = true;

    constructor(cartItems: ICartItems) {
        super("configure-accessories", CartFlowController.EVENTS.RENTAL_DONE, cartItems);
        this.optionalQuantityKey = "_accessories_quantity";
    }
}
